/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CRMMatchBypass = {
  properties: {
    cpf: {
      type: 'string',
    },
    crm: {
      type: 'string',
    },
    uf: {
      type: 'string',
    },
  },
} as const;
